module.exports = __webpack_public_path__ + "img/image16.58cdc41a.png";